// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"loading_loadingWrapper__wB1Xv","loading":"loading_loading__OnEUL"};